import React from 'react'

import BasicModal from 'components/modal/BasicModal'
import T from 'T'
import { memo } from 'utils/react'

type BasicModalProps = {
  isOpen?: boolean
  onClose: () => void
  className?: string
  children?: React.ReactNode
}

const TypedBasicModal = BasicModal as React.FC<BasicModalProps>

type ConfirmationModalProps = {
  isOpen?: boolean
  title?: string
  className?: string
  hasCancelBtn?: boolean
  cancelButtonTitle?: string
  hasProceedBtn?: boolean
  proceedButtonTitle?: string
  onCancel: () => void
  onProceed: () => void
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen = false,
  title = '',
  className = '',
  hasCancelBtn = true,
  cancelButtonTitle = T.CANCEL,
  hasProceedBtn = true,
  proceedButtonTitle = T.PROCEED,
  onCancel,
  onProceed,
}) => (
  <TypedBasicModal className={className} isOpen={isOpen} onClose={onCancel}>
    <div className="confirmation-modal">
      <div className="content">
        <h3>{title}</h3>
        <div className="action-buttons tr">
          {hasCancelBtn && <input className="cancel" type="button" value={cancelButtonTitle} onClick={onCancel} />}
          {hasProceedBtn && <input className="proceed" type="button" value={proceedButtonTitle} onClick={onProceed} />}
        </div>
      </div>
    </div>
  </TypedBasicModal>
)

export default memo(ConfirmationModal) as React.FC<ConfirmationModalProps>
